import { useEffect, useState } from "react";

const Overlay = ({ onComplete }) => {
  const [showOverlay, setShowOverlay] = useState(true);
  const [displayText, setDisplayText] = useState("");
  const fullText =
    "Merci de participer! votre feedback donnera des bonis aux employés.";

  useEffect(() => {
    let currentIndex = 0;
    const typingInterval = setInterval(() => {
      if (currentIndex <= fullText.length) {
        setDisplayText(fullText.slice(0, currentIndex));
        currentIndex++;
      } else {
        clearInterval(typingInterval);
      }
    }, 40); // Adjust typing speed here (lower = faster)

    return () => clearInterval(typingInterval);
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowOverlay(false);
      // Wait for fade out animation to complete before unmounting
      setTimeout(() => {
        onComplete?.();
      }, 400); // Match this with the transition duration
    }, 4500);

    return () => clearTimeout(timer);
  }, [onComplete]);

  return (
    <div
      className="overlay"
      style={{
        opacity: showOverlay ? 1 : 0,
        transition: "opacity 0.4s ease-in-out",
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(255, 255, 255, 1)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
      }}
    >
      <div className="text-center text-3xl text-green-600 !font-bold px-6 pb-12 sm:px-0">
        {displayText}
        <span className="animate-blink">|</span>
      </div>
    </div>
  );
};

export default Overlay;
